import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { BuilderSections } from '../../util/builder';

const shopdyiSizes = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '7/8',
  '10/12',
  '14/16',
  'One Size',
];

// eslint-disable-next-line import/prefer-default-export
export const shopdyiShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: shopdyiSizes }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '3f3eaed7ff1c4d8d9f23ce49d013e07a',
    },
  },
};
